var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.actionRight.text ||
    !!_vm.actionLeft.text ||
    !!_vm.actionMiddle.text
    ? _c("div", { staticClass: "mobile-menu" }, [
        !!_vm.actionLeft
          ? _c(
              "a",
              {
                staticClass: "mobile-menu-option",
                attrs: { href: _vm.actionLeft.nav || "#" }
              },
              [
                _vm._t("iconLeft"),
                _vm._v(
                  "\n            " + _vm._s(_vm.actionLeft.text) + "\n    "
                )
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !!_vm.actionMiddle
          ? _c(
              "a",
              {
                staticClass: "mobile-menu-option",
                attrs: { href: _vm.actionMiddle.nav || "#" }
              },
              [
                _vm._t("iconMiddle"),
                _vm._v("\n        " + _vm._s(_vm.actionMiddle.text) + "\n     ")
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !!_vm.actionRight
          ? _c(
              "a",
              {
                staticClass: "mobile-menu-option",
                attrs: { href: _vm.actionRight.nav || "#" }
              },
              [
                _vm._t("iconRight"),
                _vm._v("\n        " + _vm._s(_vm.actionRight.text) + "\n     ")
              ],
              2
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }